import React from 'react';
import List from 'antd/lib/list';
import styles from '../../Style/Metadata.module.scss';
import { isEmpty } from 'underscore';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export default function MetadataList(props: { data: { [key: string]: any } }) {
  return (
    <List
      className={styles.metadataList}
      size="small"
      bordered
      dataSource={Object.keys(props.data)}
      renderItem={(key) => {
        if (key === 'Illustration (Image)') {
          const { name, link_img } = props.data[key];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                <div>{name}</div>
                <img style={{ maxWidth: 170 }} src={link_img} alt={key} />
              </div>
            </List.Item>
          );
        } else if (
          /* else if (key === 'References (Links)') {
          const links = props.data[key];  
          const keys = Object.keys(links); 
          keys.map((key: string, index: number) => {
             return (  
              <List.Item key={index} className={styles.row}>
                <div className={styles.rowTitle}>{key}</div>
                <div className={styles.rowDetail}>
                  {links[key]}
                </div>
              </List.Item>
             )        
          }) 
        }  */
          key === 'Geographical Range' ||
          key === 'Coverage_Temporal Range'
        ) {
          const list = props.data[key] as string[];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {list.map((content, index) => {
                  return <div key={index}>{content}</div>;
                })}
              </div>
            </List.Item>
          );
        } else if (key === 'Name (Unit)') {
          const list = (props.data[key].values || []) as string[];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {list.map((content, index) => {
                  return <div key={index}>{content}</div>;
                })}
              </div>
            </List.Item>
          );
        } else if (key === 'References (Links)') {
          const isArray = Array.isArray(props.data[key]);
          const empty = isEmpty(props.data[key]);
          const links = isArray
            ? props.data[key]
            : empty
            ? []
            : props.data[key].link
            ? [
                {
                  name: props.data[key].name
                    ? props.data[key].name
                    : 'Reference',
                  link: props.data[key].link,
                },
              ]
            : [];
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {links.map((link: any, index: number) => {
                  return (
                    link &&
                    link.link && (
                      <div key={index} className={styles.row}>
                        <div
                          className={styles.link}
                          onClick={() => {
                            window.open(link.link);
                          }}
                        >
                          {link.name}
                        </div>
                      </div>
                    )
                  );
                })}
              </div>
            </List.Item>
          );
        } else if (key === 'Sample Data (.csv)') {
          const { name, link } = props.data[key];
          {
            return (
              link && (
                <List.Item className={styles.row}>
                  <div className={styles.rowTitle}>{key}</div>
                  <div className={styles.rowDetail}>
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      size="small"
                      onClick={() => {
                        window.open(link);
                      }}
                    >
                      {name}
                    </Button>
                  </div>
                </List.Item>
              )
            );
          }
        } else {
          return (
            <List.Item className={styles.row}>
              <div className={styles.rowTitle}>{key}</div>
              <div className={styles.rowDetail}>
                {isEmpty(props.data[key]) ? '--' : props.data[key]}
              </div>
            </List.Item>
          );
        }
      }}
    />
  );
}
